import { action } from 'typesafe-actions';

import { SmevRequestActionEnum } from '../enums/SmevRequestActionEnum';
import { ISmevMessageResponse } from '../../../APIPackage/SmevMessagesModule/interfaces/ISmevMessageResponse';
import { ISmevMessageCreateRequest } from '../../../APIPackage/SmevMessagesModule/interfaces/ISmevMessageCreateRequest';
import { IRequestType } from '../../../APIPackage/SmevMessagesModule/interfaces/IRequestType';
import { IRequestTemplate } from '../../../APIPackage/SmevMessagesModule/interfaces/IRequestTemplate';

export const smevRequestGetData = (searchValue?: string, systemType?: string) =>
  action(SmevRequestActionEnum.SMEV_REQUEST_GET_DATA, { searchValue, systemType });

export const smevRequestSetData = (data: ISmevMessageResponse | undefined) =>
  action(SmevRequestActionEnum.SMEV_REQUEST_SET_DATA, { data });

export const smevRequestGetCommonData = () => action(SmevRequestActionEnum.SMEV_REQUEST_GET_COMMON_DATA);

export const smevRequestSetRequestTypes = (data: IRequestType[]) =>
  action(SmevRequestActionEnum.SMEV_REQUEST_SET_REQUEST_TYPES, { data });

export const smevRequestSetRequestTemplates = (data: IRequestTemplate[]) =>
  action(SmevRequestActionEnum.SMEV_REQUEST_SET_REQUEST_TEMPLATES, { data });

export const smevRequestCreate = (request: ISmevMessageCreateRequest, systemType: string) =>
  action(SmevRequestActionEnum.SMEV_REQUEST_CREATE, { request, systemType });
